import * as React from "react";
import type { SVGProps } from "react";
const SvgBaby = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color || "#746a80"}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M92 140a12 12 0 1 1 12-12 12 12 0 0 1-12 12m72-24a12 12 0 1 0 12 12 12 12 0 0 0-12-12m-12.27 45.23a45 45 0 0 1-47.46 0 8 8 0 0 0-8.54 13.54 61 61 0 0 0 64.54 0 8 8 0 0 0-8.54-13.54M232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104m-16 0a88.11 88.11 0 0 0-84.09-87.91C120.32 56.38 120 71.88 120 72a8 8 0 0 0 16 0 8 8 0 0 1 16 0 24 24 0 0 1-48 0c0-.73.13-14.3 8.46-30.63A88 88 0 1 0 216 128" />
  </svg>
);
export default SvgBaby;
